<template>
  <div class="containerDatePiker">
    <PDropDownContainer v-model="pussOption" :placement="placement">
      <template v-slot:content>
        <div class="divInputDatePiker dedo" v-if="type !== 'flat'">
          <div>
            <p-form-input-text
              :label="label"
              :value="dateInput"
              :readonly="true"
              :invalid_feedback="invalid_feedback"
              :rules="rules"
              class="dedo"
            />
            <p-icon icon="calendar_today" type="material" class="iconInputDatePiker"></p-icon>
          </div>
        </div>
      </template>
      <div class="floatContainer_PFormDatepicker">
        <div class="divBotonesMesAno">
          <div class="divBotonMesAno dedo" @click="anoAtras">
            <p-icon icon="first_page" type="material"></p-icon>
          </div>
          <div class="divBotonMesAno dedo" @click="mesAtras">
            <p-icon icon="chevron_left" type="material">chevron_left</p-icon>
          </div>
          <div class="divTitulo">
            <span>{{ mes }} {{ ano }}</span>
          </div>
          <div class="divBotonMesAno dedo" @click="mesAdelante">
            <p-icon icon="chevron_right" type="material"></p-icon>
          </div>
          <div class="divBotonMesAno dedo" @click="anoAdelante">
            <p-icon icon="last_page" type="material"></p-icon>
          </div>
        </div>
        <div class="divDias">
          <div
            class="divDiaSemana"
            v-for="(diaSemana, index) in diasSemana"
            :key="index + 'diaSemana'"
          >
            {{ diaSemana }}
          </div>
          <div
            class="divDiaMesAnterior"
            v-for="(diaMesAnterior, index) in diasMesAnterior"
            :key="index + 'diaMesAnterior'"
          ></div>
          <div
            v-for="(diaMes, index) in diasMes"
            class="divDiaMes"
            :key="index + 'divDiaMes'"
            @click="seleccionarDia(diaMes)"
          >
            <div :class="classDiaSeleccionado(diaMes)">
              {{ diaMes }}
            </div>
          </div>

          <div
            class="divDiaMesPosterior"
            v-for="(diaMesPosterior, index) in diasMesPosterior"
            :key="index + 'diaMesPosterior'"
          ></div>
        </div>
      </div>
    </PDropDownContainer>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { format } from "date-fns";
import PFormInputText from "../PFormInput/PFormInputText.vue";
import PIcon from "../PIcon/PIcon.vue";
import { ITranslationsDatepicker, translations } from "./languajesDatepicker";
import { Placement } from "popper.js";

@Component({
  components: {
    PFormInputText,
    PIcon,
  },
})
export class PFormDatepicker extends Vue {
  @Prop({ required: true }) value!: Date;
  @Watch("value")
  onChangeValue(): void {
    this.initDate();
  }

  @Prop({ required: false, default: "es" }) language!: string;
  @Prop({ required: false, default: "dropdown" }) type!: string; // dropdown/flat/
  @Prop({ required: false, default: "" }) label!: string;
  @Prop({ required: false }) readonly!: boolean;
  @Prop({ required: false, default: undefined }) state!: boolean;
  @Prop({ required: false, default: undefined }) rules!: string;
  @Prop({ required: false, default: undefined }) invalid_feedback!: string;
  @Prop({ required: false, default: undefined }) startSelector!: Date | undefined;
  @Prop({ required: false, default: undefined }) endSelector!: Date | undefined;
  //Las siguientes propiedades maxToday y maxRangeMonth necesitan de startSelector para funcionar, no son compatibles con endSelector
  @Prop({ required: false, default: false }) maxToday!: boolean; // Marcar como dia maximo hoy
  @Prop({ required: false, default: undefined }) maxRangeMonth!: number | undefined; //Marcar como dia maximo fecha inicio mas x meses
  @Prop({ required: false, default: "bottom-start" }) placement!: Placement;
  @Prop({ required: false, default: false }) utcDate!: boolean;

  pussOption = false;
  mesMostrado = 1;
  anoMostrado = 2021;
  traductor: ITranslationsDatepicker = translations[0].translations;
  created(): void {
    const language = translations.find((tran) => tran.language === this.language)?.translations;
    if (language) {
      this.traductor = language;
    }
  }
  mounted(): void {
    this.initDate();
  }
  initDate(): void {
    if (this.value) {
      const dateValue = new Date(this.value);
      this.mesMostrado = this.getMonth(dateValue);
      this.anoMostrado = this.getFullYear(dateValue);
    } else {
      const hoy = new Date();
      this.mesMostrado = this.getMonth(hoy);
      this.anoMostrado = this.getFullYear(hoy);
    }
  }

  getDate(date: Date): number {
    return this.utcDate ? date.getUTCDate() : date.getDate();
  }

  getMonth(date: Date): number {
    return this.utcDate ? date.getUTCMonth() : date.getMonth();
  }

  getFullYear(date: Date): number {
    return this.utcDate ? date.getUTCFullYear() : date.getFullYear();
  }

  get dateInput(): string {
    if (this.value) {
      const date = new Date(this.value);
      if (this.utcDate) {
        date.setTime(date.getTime() + date.getTimezoneOffset() * 60 * 1000);
      }

      return format(date, "dd/MM/yyyy");
    } else {
      return "";
    }
  }
  get ano(): number {
    return this.anoMostrado;
  }
  get mes(): string {
    if (this.traductor) {
      return this.traductor["mes_" + (this.mesMostrado + 1)];
    } else {
      return "";
    }
  }
  get diasMesAnterior(): number[] {
    const fecha01 = new Date(this.anoMostrado, this.mesMostrado, 1);

    let diaSemana = fecha01.getDay();
    const diasAnteriores = [];
    if (diaSemana === 0) {
      diaSemana = 7;
    }
    for (let i = 1; i < diaSemana; i++) {
      diasAnteriores.push(i);
    }
    return diasAnteriores;
  }
  get diasMesPosterior(): number[] {
    const numDiasMes = this.getDate(new Date(this.anoMostrado, this.mesMostrado + 1, 0));

    const fechaUltimoDia = new Date(this.anoMostrado, this.mesMostrado, numDiasMes);
    const diaSemana = fechaUltimoDia.getDay();
    const diasPosteriores = [];
    for (let i = diaSemana; i < 7; i++) {
      diasPosteriores.push(i);
    }
    return diasPosteriores;
  }
  get diasMes(): number[] {
    const numDiasMes = this.getDate(new Date(this.anoMostrado, this.mesMostrado + 1, 0));
    const dias = [];
    for (let i = 1; i <= numDiasMes; i++) {
      dias.push(i);
    }
    return dias;
  }
  get diasSemana(): string[] {
    return [
      this.traductor?.L,
      this.traductor?.M,
      this.traductor?.X,
      this.traductor?.J,
      this.traductor?.V,
      this.traductor?.S,
      this.traductor?.D,
    ];
  }

  get fechaFin(): Date | undefined {
    if (this.endSelector) {
      return this.endSelector;
    } else if (this.startSelector && (this.maxRangeMonth || this.maxToday)) {
      let fechaMax = new Date(this.startSelector);
      if (this.maxRangeMonth) {
        if (this.utcDate) {
          fechaMax.setTime(fechaMax.getTime() + fechaMax.getTimezoneOffset() * 60 * 1000);
        }
        fechaMax.setMonth(this.getMonth(fechaMax) + this.maxRangeMonth);
        let today = new Date();
        if (this.maxToday && fechaMax > today) {
          fechaMax = today;
        }
      } else {
        fechaMax = new Date();
      }
      let fechaFin = new Date(this.value);
      if (fechaMax < fechaFin) {
        this.$emit("input", fechaMax);
      }
      return fechaMax;
    }

    return undefined;
  }

  seleccionarDia(DiaSeleccionado: number): void {
    const fechaHora = new Date(this.anoMostrado, this.mesMostrado, DiaSeleccionado, 0, 0, 0);
    if (this.utcDate) {
      fechaHora.setTime(fechaHora.getTime() - fechaHora.getTimezoneOffset() * 60 * 1000);
    }
    let estaEnRango = true;
    if (
      this.startSelector &&
      fechaHora.getTime() <
        (typeof this.startSelector === "string"
          ? new Date(this.startSelector)
          : this.startSelector
        ).getTime()
    ) {
      estaEnRango = false;
    }
    if (
      this.fechaFin &&
      fechaHora.getTime() >
        (typeof this.fechaFin === "string" ? new Date(this.fechaFin) : this.fechaFin).getTime()
    ) {
      estaEnRango = false;
    }

    if (estaEnRango) {
      this.pussOption = false;
      this.$emit("input", fechaHora);
    }
  }
  classDiaSeleccionado(dia: number): string {
    const fechaHoraComparadora = new Date(this.anoMostrado, this.mesMostrado, dia, 0, 0, 0);
    if (this.utcDate) {
      fechaHoraComparadora.setTime(
        fechaHoraComparadora.getTime() - fechaHoraComparadora.getTimezoneOffset() * 60 * 1000
      );
    }
    let estaEnRango = true;
    let classDia = "divDiaMesDisabled";
    if (
      this.startSelector &&
      fechaHoraComparadora.getTime() <
        (typeof this.startSelector === "string"
          ? new Date(this.startSelector)
          : this.startSelector
        ).getTime()
    ) {
      estaEnRango = false;
    }
    if (
      this.fechaFin &&
      fechaHoraComparadora.getTime() >
        (typeof this.fechaFin === "string" ? new Date(this.fechaFin) : this.fechaFin).getTime()
    ) {
      estaEnRango = false;
    }

    if (estaEnRango) {
      classDia = "divDiaMesEnable";
    }

    if (this.value) {
      const dateValue = new Date(this.value);
      const diaSelec = new Date(
        this.getFullYear(dateValue),
        this.getMonth(dateValue),
        this.getDate(dateValue)
      );
      const diaCurrent = new Date(this.anoMostrado, this.mesMostrado, dia);
      if (diaSelec.getTime() === diaCurrent.getTime()) {
        return "diaSeleccionado";
      } else {
        return classDia;
      }
    } else {
      return classDia;
    }
  }

  anoAtras(): void {
    this.anoMostrado = this.anoMostrado - 1;
  }
  mesAtras(): void {
    if (this.mesMostrado === 0) {
      //cambiamos de año
      this.mesMostrado = 11;
      this.anoMostrado = this.anoMostrado - 1;
    } else {
      this.mesMostrado = this.mesMostrado - 1;
    }
  }
  mesAdelante(): void {
    if (this.mesMostrado === 11) {
      //pasamos de año
      this.mesMostrado = 0;
      this.anoMostrado = this.anoMostrado + 1;
    } else {
      this.mesMostrado = this.mesMostrado + 1;
    }
  }
  anoAdelante(): void {
    this.anoMostrado = this.anoMostrado + 1;
  }
}
export default PFormDatepicker;
</script>
<style lang="scss" scoped>
.divTituloCierre {
  position: absolute;
  right: 1px;
  top: -5px;
}
.containerDatePiker {
  position: relative;
}

.divDatePikerFlat {
  background-color: #fff;
  width: 250px;
  min-height: 100px;
}
.divBotonesMesAno {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 5px;
}
.divBotonMesAno {
  color: #6f6f6f;
}
.divBotonesMesAno span {
  width: 15%;
}
.divTitulo {
  flex: 0 0 55%;
  text-align: center;
  object-fit: contain;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #6f6f6f;
  padding-bottom: 4px;
}
.divDias {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.divDiaSemana,
.divDiaMesAnterior,
.divDiaMes,
.divDiaMesPosterior {
  flex: 0 0 14.28%;
  text-align: center;
  padding: 3px 0;
  font-size: 0.8rem;
  display: flex;
  justify-content: center;
}
.divDiaMesEnable,
.divDiaMesDisabled,
.diaSeleccionado {
  width: 28px;
  height: 28px;
  padding-top: 4px;
}
.divDiaMesEnable {
  cursor: pointer;
}
.divDiaMesDisabled {
  opacity: 0.5;
}
.diaSeleccionado {
  background-color: var(--amarillo-prosegur);
  border-radius: 100%;
}

.divDiaSemana {
  color: #b7b7b7;
  padding-bottom: 8px;
}

.divHora {
  background-color: var(--amarillo-prosegur);
  color: var(--blanco-prosegur);
  padding: 5px;
  text-align: center;
}
.inputHora {
  border: none;
}
.divInputDatePiker {
  position: relative;
}
.iconInputDatePiker {
  position: absolute;
  right: 8px;
  top: 38px;
}
.dedo {
  cursor: pointer;
}
.floatContainer_PFormDatepicker {
  padding: 1rem;
}
</style>
